import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, watch } from "vue";
import { onboardingStore, useTimeDisplay } from "@/hooks";
import { FlexBox, Icon, ListItem } from "@/components/common";


/**
 * A sub-step for displaying an in-progress job during onboarding.
 */
const __default__ = {
  name: "JobLoadingSubStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const uploadedJob = computed(() => onboardingStore.uploadedJob);

const { displayTime, resetTime, stopTime } = useTimeDisplay({
  getStart: () => onboardingStore.uploadedJob?.startedAt || "",
  getEnd: () => onboardingStore.uploadedJob?.completedAt || "",
});

const progress = computed(
  () => `${onboardingStore.uploadProgress} (${displayTime.value})`
);

onMounted(() => resetTime());

watch(
  () => uploadedJob.value,
  () => resetTime()
);

watch(
  () => uploadedJob.value?.status,
  (status) => {
    if (status !== "IN_PROGRESS") stopTime();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!uploadedJob.value)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_circular_progress, {
              color: "primary",
              indeterminate: "",
              size: "md"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!uploadedJob.value)
      ? (_openBlock(), _createBlock(_unref(ListItem), {
          key: 1,
          dense: "",
          title: uploadedJob.value.name,
          subtitle: progress.value,
          class: "q-mt-md"
        }, {
          icon: _withCtx(() => [
            (uploadedJob.value.status === 'IN_PROGRESS')
              ? (_openBlock(), _createBlock(_component_q_circular_progress, {
                  key: 0,
                  color: "gradient",
                  indeterminate: "",
                  size: "md"
                }))
              : (uploadedJob.value.status === 'COMPLETED')
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 1,
                    variant: "job-complete",
                    color: "primary",
                    size: "md"
                  }))
                : (uploadedJob.value.status === 'FAILED')
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 2,
                      variant: "job-fail",
                      color: "error",
                      size: "md"
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "subtitle"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})